import type { UserAddress } from './user-address';

export const ENDPOINT = 'api/app/address-location';

export type Place = Omit<UserAddress, 'id' | 'complement' | 'reference'>;
